export default "__VITE_ASSET__Dv1xHI9P__"